import { render, staticRenderFns } from "./SendEmergencyMsgLanding.vue?vue&type=template&id=778264b6"
import script from "./SendEmergencyMsgLanding.vue?vue&type=script&lang=js"
export * from "./SendEmergencyMsgLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports